import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from '../services/security.service';

/**
 * SuperAdminGuard - Restringe una ruta a usuarios super admin (ROLE_admin + isAdmin).
 *
 * La autorización deriva siempre de SecurityService.isSuperAdmin() (JWT firmado
 * decodificado), nunca de localStorage. ROLE_onboarding_user_admin (admin limitado
 * a un solo onboarding) NO pasa este guard.
 */
export const SuperAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const securityService = inject(SecurityService);

  if (securityService.isSuperAdmin()) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};
